module.exports = __webpack_public_path__ + "static/img/App item-5.d527596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls39/App item-5.png
// module id = lIFY
// module chunks = 12